export enum ModuleTypeEnum {
    JuvoPos = 'JuvoPos', 
    JuvoMobile = 'JuvoMobile', 
    JuvOnline = 'JuvOnline', 
    JuvoKiosk = 'JuvoKiosk', 
    JuvoPerks = 'JuvoPerks'
}